import { render, staticRenderFns } from "./AlbumEditContainer.vue?vue&type=template&id=cbce7aa2&scoped=true"
import script from "./AlbumEditContainer.vue?vue&type=script&lang=js"
export * from "./AlbumEditContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbce7aa2",
  null
  
)

export default component.exports